const runFixedIncomeAnimations = (duration, premiumsParent) => {
	const numberOfCharts = 3;
	// the animation requires that the chart rectangles stay visible,
	// they DO NOT animate "off the screen"
	// the fixed income content must wait until the equity content animates to visibility hidden
	// use requestAnimationFrame to wait for a duration of time
	// duration of time = total animation time of equity content animating to visibility hidden)
	// once the time has passed trigger the Fixed income animations
	const start = performance.now();
	const step = () => {
		const now = performance.now();
		const delta = Math.min((now - start) / duration, 1);
		if (delta < 1) {
			requestAnimationFrame(step);
		} else {
			const animationSequence = [];
			// classes to fully hide all equity charts content (position: absolute)
			// classes to animate on fixed income charts content
			for (let i = 0; i < numberOfCharts; i++) {
				animationSequence.push(
					{
						parent: `.ddiff-premium-chart-${i}`,
						elementToAnimate: ".ddiff-equity-copy",
						classToAdd: "ddiff-premiums-hide"
					},
					{
						parent: `.ddiff-premium-chart-${i}`,
						elementToAnimate: ".ddiff-equity-svg",
						classToAdd: "ddiff-premiums-hide"
					}
				);
			}
			const fixedCharts = premiumsParent.querySelectorAll(
				".ddiff-premium-chart-3, .ddiff-premium-chart-4, .ddiff-premium-chart-5"
			);
			if (fixedCharts.length)
				fixedCharts.forEach((chart) => chart.classList.add("ddiff-premium-chart-show"));

			for (let i = 3; i < numberOfCharts + 3; i++) {
				animationSequence.push(
					{
						parent: `.ddiff-premium-chart-${i}`,
						elementToAnimate: ".ddiff-fixed-copy",
						classToRemove: "ddiff-premiums-hide",
						classToAdd: "ddiff-fixed-copy-animate"
					},
					{
						parent: `.ddiff-premium-chart-${i}`,
						elementToAnimate: ".ddiff-fixed-svg",
						classToRemove: "ddiff-premiums-hide",
						classToAdd: "ddiff-fixed-svg-animate"
					}
				);
			}
			// hide equity disclosure and little i
			// animate on fixed discloure and little i
			animationSequence.push(
				{
					parent: ".ddiff-premiums-disclosure",
					elementToAnimate: ".ddiff-equity-disclosure",
					classToAdd: "ddiff-premiums-disclosure-hide"
				},
				{
					parent: ".ddiff-premiums-disclosure",
					elementToAnimate: ".ddiff-fixed-disclosure",
					classToRemove: "ddiff-premiums-disclosure-hide",
					classToAdd: "ddiff-premiums-disclosure-show"
				}
			);
			// find the parent element
			// find the element that needs to animate
			// add the animation class
			// remove class if necessary
			animationSequence.forEach((sequence) => {
				const parent = premiumsParent.querySelector(sequence.parent);
				if (parent) {
					const div = parent.querySelectorAll(sequence.elementToAnimate);
					if (div.length) {
						if (div.length > 1) {
							div.forEach((d) => {
								if (sequence.classToRemove) d.classList.remove(sequence.classToRemove);
								d.classList.add(sequence.classToAdd);
							});
						} else {
							if (sequence.classToRemove) div[0].classList.remove(sequence.classToRemove);
							div[0].classList.add(sequence.classToAdd);
						}
					}
				}
			});
			// hide equity little i (position: absolute)
			// animate fixed little i on screen
			const littleIEquity = premiumsParent.querySelector(".ddiff-premiums-little-i-equity");
			if (littleIEquity) littleIEquity.classList.add("ddiff-premiums-little-i-hide");
			const littleIFixed = premiumsParent.querySelector(".ddiff-premiums-little-i-fixed");
			if (littleIFixed) {
				littleIFixed.classList.remove("ddiff-premiums-little-i-hide");
				littleIFixed.classList.add("ddiff-premiums-little-i-show");
			}
		}
	};
	step();
};

const handlePremiumsExhibitToggle = () => {
	const premiums = document.querySelector(".ddiff-animated-exhibit-premiums");
	const numberOfCharts = 3;
	if (premiums) {
		const premiumsSwitchContainer = premiums.querySelector(".ddiff-premiums-switch-container");
		const equitySwitchLabel = premiums.querySelector(".ddiff-switch-title-equity");
		const fixedIncomeSwitchLabel = premiums.querySelector(".ddiff-switch-title-fixed");

		if (premiumsSwitchContainer) {
			// find toggle switch
			const premiumsSwitchContainerInput =
				premiumsSwitchContainer.querySelector("input[type=checkbox]");

			const handleToggle = () => {
				let isEquity = true;
				// switch color of label and move pulsating switch
				if (equitySwitchLabel) {
					equitySwitchLabel.classList.toggle("tc-poppy");
					isEquity = equitySwitchLabel.classList.contains("tc-poppy");
				}
				if (fixedIncomeSwitchLabel) fixedIncomeSwitchLabel.classList.toggle("tc-poppy");

				// change data-a-text GA4 attribute
				premiumsSwitchContainerInput.setAttribute(
					"data-a-text",
					isEquity ? equitySwitchLabel.innerHTML : fixedIncomeSwitchLabel.innerHTML
				);

				// grab all equity content and fixed content that needs to hide/show
				const equityElements = premiums.querySelectorAll(
					".ddiff-equity-copy, .ddiff-equity-svg, .ddiff-equity-disclosure, .ddiff-premiums-little-i-equity"
				);
				const fixedElements = premiums.querySelectorAll(
					".ddiff-fixed-copy, .ddiff-fixed-svg, .ddiff-fixed-disclosure, .ddiff-premiums-little-i-fixed"
				);

				const fixedCharts = premiums.querySelectorAll(
					".ddiff-premium-chart-3, .ddiff-premium-chart-4, .ddiff-premium-chart-5"
				);

				// STEP 2 animated fixed -> NON animated equity
				if (
					isEquity &&
					premiums.querySelector(".ddiff-fixed-svg-animate") &&
					premiums.querySelectorAll(".ddiff-premiums-show").length === 0
				) {
					// toggle back from animated fixed to a NON animated equity
					if (equityElements.length) {
						[...equityElements].forEach((el) => {
							if (el.classList.contains("ddiff-equity-copy")) {
								el.classList.remove("ddiff-premium-copy-hide");
								el.classList.remove("ddiff-premium-resize-static");
								el.classList.add("ddiff-premiums-show");
							} else if (el.classList.contains("ddiff-equity-svg")) {
								el.classList.remove("ddiff-premium-svg-hide");
								el.classList.remove("ddiff-premium-resize-static");
								el.classList.add("ddiff-premiums-show");
							} else if (el.classList.contains("ddiff-equity-disclosure")) {
								el.classList.remove("ddiff-premiums-disclosure-hide");
								el.classList.add("ddiff-premiums-disclosure-show");
							} else if (el.classList.contains("ddiff-premiums-little-i-equity")) {
								el.classList.remove("ddiff-premiums-little-i-hide");
								el.classList.add("ddiff-premiums-little-i-show");
							}
						});
						[...fixedElements].forEach((el) => {
							if (el.classList.contains("ddiff-fixed-copy")) {
								el.classList.remove("ddiff-fixed-copy-animate");
								el.classList.remove("ddiff-premium-resize-static");
								el.classList.add("ddiff-premiums-hide");
							} else if (el.classList.contains("ddiff-fixed-svg")) {
								el.classList.remove("ddiff-fixed-svg-animate");
								el.classList.add("ddiff-premiums-hide");
							} else if (el.classList.contains("ddiff-fixed-disclosure")) {
								el.classList.remove("ddiff-premiums-disclosure-show");
								el.classList.add("ddiff-premiums-disclosure-hide");
							} else if (el.classList.contains("ddiff-premiums-little-i-fixed")) {
								el.classList.remove("ddiff-premiums-little-i-show");
								el.classList.add("ddiff-premiums-little-i-hide");
							}
						});
						if (fixedCharts.length)
							fixedCharts.forEach((el) => el.classList.remove("ddiff-premium-chart-show"));
					}
				} else if (!isEquity && premiums.querySelector(".ddiff-equity-copy.ddiff-premiums-show")) {
					// STEP 3
					// toggle to a NON animated fixed from a NON animated equity
					[...equityElements].forEach((el) => {
						if (el.classList.contains("ddiff-equity-disclosure")) {
							el.classList.remove("ddiff-premiums-disclosure-show");
							el.classList.add("ddiff-premiums-disclosure-hide");
						} else if (el.classList.contains("ddiff-premiums-little-i-equity")) {
							el.classList.remove("ddiff-premiums-little-i-show");
							el.classList.add("ddiff-premiums-little-i-hide");
						} else {
							el.classList.remove("ddiff-premiums-show");
							el.classList.add("ddiff-premiums-hide");
						}
					});
					[...fixedElements].forEach((el) => {
						if (el.classList.contains("ddiff-fixed-disclosure")) {
							el.classList.remove("ddiff-premiums-disclosure-hide");
							el.classList.add("ddiff-premiums-disclosure-show");
						} else if (el.classList.contains("ddiff-premiums-little-i-fixed")) {
							el.classList.remove("ddiff-premiums-little-i-hide");
							el.classList.add("ddiff-premiums-little-i-show");
						} else {
							el.classList.remove("ddiff-premiums-hide");
							el.classList.add("ddiff-premiums-show");
						}
					});
					if (fixedCharts.length)
						fixedCharts.forEach((el) => el.classList.add("ddiff-premium-chart-show"));
				} else if (isEquity && premiums.querySelector(".ddiff-fixed-copy.ddiff-premiums-show")) {
					// STEP 4
					// toggle back to a NON animated equity from a NON animated fixed
					[...equityElements].forEach((el) => {
						if (el.classList.contains("ddiff-equity-disclosure")) {
							el.classList.add("ddiff-premiums-disclosure-show");
							el.classList.remove("ddiff-premiums-disclosure-hide");
						} else if (el.classList.contains("ddiff-premiums-little-i-equity")) {
							el.classList.add("ddiff-premiums-little-i-show");
							el.classList.remove("ddiff-premiums-little-i-hide");
						} else {
							el.classList.add("ddiff-premiums-show");
							el.classList.remove("ddiff-premiums-hide");
						}
					});
					[...fixedElements].forEach((el) => {
						if (el.classList.contains("ddiff-fixed-disclosure")) {
							el.classList.add("ddiff-premiums-disclosure-hide");
							el.classList.remove("ddiff-premiums-disclosure-show");
						} else if (el.classList.contains("ddiff-premiums-little-i-fixed")) {
							el.classList.add("ddiff-premiums-little-i-hide");
							el.classList.remove("ddiff-premiums-little-i-show");
						} else {
							el.classList.add("ddiff-premiums-hide");
							el.classList.remove("ddiff-premiums-show");
						}
					});
					if (fixedCharts.length)
						fixedCharts.forEach((el) => el.classList.remove("ddiff-premium-chart-show"));
				} else {
					// STEP 1: ON FIRST TOGGLE OF SWITCH equity -> fixed
					// add classes to animate equity content "off screen" (slide down/opacity 0)
					const firstAnimationSequence = [];
					// animation classes needed to animate equity charts content "off screen"
					for (let i = 0; i < numberOfCharts; i++) {
						firstAnimationSequence.push(
							{
								parent: `.ddiff-premium-chart-${i}`,
								elementToAnimate: ".ddiff-equity-copy",
								classToRemove: "ddiff-equity-copy-animate",
								classToAdd: "ddiff-premium-copy-hide"
							},
							{
								parent: `.ddiff-premium-chart-${i}`,
								elementToAnimate: ".ddiff-equity-svg",
								classToRemove: "ddiff-equity-svg-animate",
								classToAdd: "ddiff-premium-svg-hide"
							}
						);
					}
					firstAnimationSequence.push({
						parent: ".ddiff-premiums-disclosure",
						elementToAnimate: ".ddiff-equity-disclosure",
						classToAdd: "ddiff-premiums-disclosure-hide"
					});
					// find the parent of the element that needs classes toggled
					// find the element that needs to animate off
					// remove the animate on class
					// add the animate off classes
					firstAnimationSequence.forEach((sequence) => {
						const parent = premiums.querySelector(sequence.parent);
						if (parent) {
							const div = parent.querySelectorAll(sequence.elementToAnimate);
							if (div.length) {
								if (div.length > 1) {
									div.forEach((d) => {
										d.classList.remove(sequence.classToRemove);
										d.classList.add(sequence.classToAdd);
									});
								} else {
									div[0].classList.remove(sequence.classToRemove);
									div[0].classList.add(sequence.classToAdd);
								}
							}
						}
					});
					// animate equity little i "off screen"
					const littleIEquity = premiums.querySelector(".ddiff-premiums-little-i-equity");
					if (littleIEquity) {
						littleIEquity.classList.add("ddiff-premiums-little-i-hide");
					}

					runFixedIncomeAnimations(300, premiums);
				}
			};

			// Add event listener to input
			premiumsSwitchContainerInput.addEventListener("click", handleToggle);

			// Add event listener to labels but only fire when the premiums are on the opposite tab
			if (equitySwitchLabel) {
				equitySwitchLabel.addEventListener("click", () => {
					if (premiums.querySelector(".ddiff-equity-copy.ddiff-premiums-hide")) {
						premiumsSwitchContainerInput.checked = false;
						handleToggle();
					}
				});
			}

			if (fixedIncomeSwitchLabel) {
				fixedIncomeSwitchLabel.addEventListener("click", () => {
					if (premiums.querySelector(".ddiff-fixed-copy.ddiff-premiums-hide")) {
						premiumsSwitchContainerInput.checked = true;
						handleToggle();
					}
				});
			}
		}
	}
};

export { handlePremiumsExhibitToggle };
